import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "site-footer" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "footer-content" };
const _hoisted_4 = { class: "footer-section" };
const _hoisted_5 = { class: "footer-section" };
const _hoisted_6 = { class: "footer-bottom" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'Footer',
    setup(__props) {
        /**
         * 网站页脚组件
         */
        const currentYear = new Date().getFullYear();
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "footer-section" }, [
                            _createElementVNode("h4", null, "关于本站"),
                            _createElementVNode("p", null, [
                                _createTextVNode(" Software defines the future"),
                                _createElementVNode("br"),
                                _createTextVNode(" 记录技术成长，分享思考感悟 ")
                            ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_4, [
                            _cache[4] || (_cache[4] = _createElementVNode("h4", null, "快速链接", -1 /* CACHED */)),
                            _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: "/" }, {
                                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                                _createTextVNode("首页", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: "/article" }, {
                                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                _createTextVNode("文章", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: "/archive" }, {
                                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                _createTextVNode("归档", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: "/about" }, {
                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                _createTextVNode("关于", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _cache[9] || (_cache[9] = _createElementVNode("h4", null, "分类导航", -1 /* CACHED */)),
                            _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: "/article?category=tech" }, {
                                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                _createTextVNode("技术博客", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: "/article?category=life" }, {
                                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                _createTextVNode("生活随笔", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: "/article?category=reading" }, {
                                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                _createTextVNode("读书笔记", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: "/projects" }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                _createTextVNode("项目展示", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ])
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "footer-section" }, [
                            _createElementVNode("h4", null, "订阅方式"),
                            _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                        href: "/rss.xml",
                                        target: "_blank"
                                    }, "RSS 订阅")
                                ]),
                                _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                        href: "#",
                                        target: "_blank"
                                    }, "邮件订阅")
                                ])
                            ])
                        ], -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "footer-beian" }, [
                            _createElementVNode("a", {
                                class: "footer-beian__link",
                                href: "https://beian.miit.gov.cn/",
                                target: "_blank",
                                rel: "noopener noreferrer"
                            }, "浙ICP备2026029595号-1"),
                            _createElementVNode("span", {
                                class: "footer-beian__sep",
                                "aria-hidden": "true"
                            }, "·"),
                            _createElementVNode("a", {
                                class: "footer-beian__link footer-beian__gongan",
                                href: "https://beian.mps.gov.cn/#/query/webSearch?code=33010802014487",
                                rel: "noreferrer",
                                target: "_blank"
                            }, "浙公网安备33010802014487号")
                        ], -1 /* CACHED */)),
                        _createElementVNode("p", null, "© " + _toDisplayString(_unref(currentYear)) + " Software defines the future. All rights reserved.", 1 /* TEXT */),
                        _cache[13] || (_cache[13] = _createElementVNode("p", { class: "powered-by" }, " Powered by Vue.js & Java ", -1 /* CACHED */))
                    ])
                ])
            ]));
        };
    }
});
